/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import {
  attendanceActions,
  authActions,
  userActions
} from "../../../redux/actions";
import Button from "../../../component/button/Button";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import P from "../../../component/smallComponents/P";
import SelectInput from "../../../component/input/SelectInput";
import {
  renderAccessLocation,
  toastHelper
} from "../../../constant/helper/helper";

import LeftNav from "../../../component/leftSideNav/LeftNav";
import { ToastContainer } from "react-toastify";
import TopBar from "../../../component/topBar/TopBar";

const ChangeModule = () => {
  const dispatch = useDispatch();

  const onLogoutPress = () => {
    dispatch(userActions.unmountAllUsersData());
    dispatch(attendanceActions.unmountAttendanceData());
    dispatch(authActions.logoutUser());
  };

  const [selectLocation, setSelectLocation] = useState("");
  const [locationName, setLocationName] = useState("");
  const [moduleType, setModuleType] = useState("");
  const [locationId, setLocationId] = useState("");
  const [employeeAccess] = useState(
    JSON.parse(localStorage.employeeAccess)
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    if (locationName !== "") {
      const selectedModule = employeeAccess.filter((filterModule) => {
        return (
          filterModule.locationId
            .toLowerCase()
            .indexOf(locationId.toLowerCase()) !== -1
        );
      });
      localStorage.setItem(
        "selectedModule",
        JSON.stringify(selectedModule)
      );
      localStorage.setItem("locationName", locationName);
      localStorage.setItem("moduleType", moduleType);
      localStorage.setItem("locationId", locationId);
      toastHelper(
        "success",
        `Module Changed to ${locationName} of type ${moduleType}`
      );
    } else {
      toastHelper("error", "Please Select Location");
    }
  };

  useEffect(() => {
    dispatch(authActions.clearAuthErrors());
    dispatch(authActions.clearAuthResult());
    dispatch(authActions.setAuthLoading(false));
    return () => {
      dispatch(authActions.clearAuthErrors());
      dispatch(authActions.clearAuthResult());
      dispatch(authActions.setAuthLoading(false));
    };
  }, []);

  const onSelectLocation = (e) => {
    const { value } = e.target;
    setSelectLocation(value);

    employeeAccess.filter((accessData, i) => {
      const checkModuleOfEmployee =
        accessData.locationId + " / " + accessData.moduleType;
      if (checkModuleOfEmployee === value) {
        setLocationName(accessData.locationName);
        setModuleType(accessData.moduleType);
        setLocationId(accessData.locationId);
      }
    });
  };

  return (
    <div className="wrapper">
      <LeftNav />
      <ToastContainer />
      <div className="content-page">
        <TopBar title="Change Module" />
        <div className="content">
          <div className="container-fluid">
            <div className="authentication-bg">
              <div className="account-pages mt-5 mb-5">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-5">
                      <div className="card">
                        <div className="card-header pt-4 text-center bg-dark">
                          <span>
                            <img
                              src="https://i.imgur.com/ahvlkuu.png"
                              alt=""
                              height="35"
                            />
                          </span>
                        </div>
                        <div className="card-body p-4 bg-dark">
                          <div className="text-center w-75 m-auto">
                            <HeaderTag
                              type="h4"
                              title="Change Project"
                              isClassName={true}
                              className="text-white text-center mt-0 font-weight-bold"
                            />
                            <P title="Please Select Your Project to Access Dashboard" />
                          </div>
                          <form onSubmit={onSubmit}>
                            <SelectInput
                              required={true}
                              textWhite={true}
                              isLabeled={true}
                              value={selectLocation}
                              label="Select Project"
                              onChange={onSelectLocation}
                            >
                              {renderAccessLocation(employeeAccess)}
                            </SelectInput>
                            <div className="form-group mb-0 text-center mt-3">
                              <Button
                                title="Submit"
                                icon="mdi mdi-login"
                                type="submit"
                                isBackgroundColor={true}
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="text-center w-75 m-auto">
                      <P
                        title="This site is available for Authorized users. If you
                      are not authorized user, please  don't attempt to
                      login. All activities performed on this site are
                      logged and monitored."
                      />
                      <div className="form-group mb-0 text-center mt-3">
                        <Button
                          title="LOGOUT"
                          icon="mdi mdi-login"
                          type="button"
                          onClick={onLogoutPress}
                          isBackgroundColor={false}
                          className="btn btn-dark"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <footer className="footer footer-alt">
                <p>
                  Developed and maintain by{" "}
                  <strong className="text-dark">
                    VITORSCAPE Copyright ©
                  </strong>
                </p>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeModule;
